/**
 * Admin/staff data source for the shared AI Providers health chip
 * (ADR-034 / ADR-041). Wires the chip's injected fetchers to admin-api, which
 * reads the live probe table with a cold-start live-probe fallback. Unchanged
 * behaviour from the pre-re-home staff chip — only the wiring moved.
 */
// ADR-071 D7 / §9 — staff-owned navbar fork. Types come from the staff copy of
// the chip's hook, not @portal-shared/navbar.
import type {
  AiProvidersSource,
  ServerResult,
  LatencyHistoryResult,
} from '../components/navbar/useAiProvidersHealth';
import { adminApi } from './api-client';

export const adminAiProvidersSource: AiProvidersSource = {
  fetchSnapshot: () => adminApi<ServerResult>('/admin/diagnostics/ai-providers'),
  fetchHistory: () =>
    adminApi<LatencyHistoryResult>('/admin/diagnostics/ai-providers/latency-history'),
};
